import * as React from 'react'

export function PresetsRelax(props) {
  return (
    <svg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M23.887 22.068c-1.752 2.26-4.437 3.775-7.425 3.914-.08.003-.158.011-.238.012-.14.003-.275-.007-.413-.01-5.417-.16-9.778-4.592-9.808-10.04.001-.202.011-.402.026-.602.028-.389.153-1.005.306-1.365a4.835 4.835 0 015.076-2.909c2.33.285 4.205 2.607 4.253 4.954a5.748 5.748 0 005.739 5.618 5.5 5.5 0 001.91-.342c.469-.172.882.374.574.77M16 4C9.373 4 4 9.373 4 16s5.373 12 12 12 12-5.373 12-12S22.627 4 16 4'
        fill='currentColor'
        fillRule='evenodd'
      />
    </svg>
  )
}
